/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'person': {
    width: 19,
    height: 18,
    viewBox: '0 0 19 18',
    data: '<path pid="0" d="M9.5 0C5.898 0 2.86 2.5 1.885 5.913 1.01 6.44.5 7.455.5 8.643c0 1.723 1.048 3.119 2.77 3.119a.69.69 0 00.691-.693V6.216c0-.318-.226-.569-.519-.65C4.452 3.084 6.786 1.344 9.5 1.344c2.713 0 5.047 1.74 6.058 4.224-.294.08-.52.33-.52.65v4.852c0 .383.31.693.693.693.16 0 .305-.02.454-.043-.224 1.293-.767 2.257-1.32 2.923-.283.345-.61.651-.973.91a2.383 2.383 0 01-.325.195l-.087.044h-1.298c-.249-.724-1.042-1.257-1.99-1.257-1.147 0-2.077.776-2.077 1.733 0 .957.93 1.733 2.077 1.733.948 0 1.741-.532 1.99-1.256h1.363c.234 0 .294-.062.434-.13.138-.068.302-.16.475-.282a6.01 6.01 0 001.17-1.083c.728-.88 1.408-2.187 1.577-3.942.817-.543 1.299-1.52 1.299-2.665 0-1.187-.511-2.202-1.385-2.729C16.138 2.5 13.1 0 9.5 0z" _fill="#1E1E1E"/>'
  }
})
